<template>
  <div class="carousel">
    <img
      alt="Carrossel"
      v-for="(image, index) in images"
      :key="index"
      :src="require(`../assets/${image}`)"
      :class="{ active: currentIndex === index }"
      class="carousel-image"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: ['001.png', '002.png', '003.png', '004.png', '005.png'],
      currentIndex: 0
    };
  },
  mounted() {
    this.startCarousel();
  },
  methods: {
    startCarousel() {
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }, 5 * 1000);
    }
  }
};
</script>

<style scoped>
.carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  opacity: 0;
  transition: opacity 2s ease-in-out;
}

.carousel-image.active {
  opacity: 1;
}
</style>
